import { airlineLogoSrc } from "@northstar/dispatch-core";
import type { CompanionApi } from "../useCompanion";
import { MoreView } from "./MoreView";

/** About, theme, refresh, sign-out, and the existing account menu. Nothing from the header is dropped. */
export function PilotMore({
  api,
  refreshing,
  onRefresh,
  onAbout,
  drafts,
  onOpenDraft,
  companyName,
  companyLogo = "",
  menuUser,
  menuBase,
}: {
  api: CompanionApi;
  refreshing: boolean;
  onRefresh?: () => void;
  onAbout: () => void;
  drafts: { tripId: string; label: string }[];
  onOpenDraft?: (tripId: string) => void;
  companyName: string;
  companyLogo?: string;
  menuUser: string;
  menuBase: string;
}) {
  const themeLabel = api.chrome.theme === "light" ? "Night" : "Day";
  return (
    <div data-testid="pilot-more">
      <section className="panel" data-testid="more-actions">
        <p className="kicker">More</p>
        <div className="row">
          <button
            type="button"
            className="btn"
            data-testid="theme-toggle"
            onClick={() => api.setChrome({ theme: api.chrome.theme === "light" ? "dark" : "light" })}
          >
            {themeLabel}
          </button>
          {onRefresh ? (
            <button type="button" className="btn ghost" data-testid="refresh-board" onClick={onRefresh} disabled={refreshing}>
              {refreshing ? "Refreshing" : "Refresh"}
            </button>
          ) : null}
          <button type="button" className="btn ghost" data-testid="about-open" onClick={onAbout}>
            About
          </button>
          <button type="button" className="btn ghost" data-testid="sign-out" onClick={() => void api.signOut()}>
            Sign out
          </button>
        </div>
      </section>
      <section className="panel" data-testid="side-menu">
        <p className="kicker">Account</p>
        <h2>{menuUser || "Pilot"}</h2>
        <p className="company-heading">
          {airlineLogoSrc(companyLogo) ? <img className="company-kicker-logo" src={airlineLogoSrc(companyLogo) ?? ""} alt="" /> : null}
          {companyName}
        </p>
        <p className="muted">{menuBase ? `Base ${menuBase}` : "No base on this board"}</p>
        <h2>Log drafts</h2>
        {drafts.length ? (
          <ul className="pilot-list">
            {drafts.map((row) => (
              <li key={row.tripId}>
                <button type="button" className="log-time" onClick={() => onOpenDraft?.(row.tripId)}>
                  {row.label}
                </button>
              </li>
            ))}
          </ul>
        ) : (
          <p className="muted">No saved log drafts.</p>
        )}
      </section>
      <MoreView api={api} />
    </div>
  );
}
